import "./animation";
import "./lotteryExplorer";
import "./header";
import "./app";
import "./help";
import "./helpMoreNovice";
import "./helpMoreTutorial";
import "./tnc";
import "./themeVariantOverride";
import "./modalFeedback";
import { USER_STATUS } from "./util";

function onBannerClicked(redirectUrl, redirectGroup, redirectPage) {
  const isLoggedIn = $(".before-login.hide").length !== 0;

  if (redirectGroup === 0) {
    /**
     * Promo
     * @type {string}
     */
    const theme = window.themeName;
    if (theme && theme.includes("wdl")) {
      return;
    } else {
      if (redirectPage !== "default") {
        $("#modal-promo").addClass("active");

        $(".promo-detail-container")
          .find(`.promo-detail-item[data-promoid="${redirectPage}"]`)
          .removeClass("hide")
          .siblings()
          .addClass("hide");
      } else {
        $("#modal-promo").addClass("active");
        $(".promo-list-wrapper").find(".promo-item").not(".hide").first().trigger("click");
      }
    }
  } else if (redirectGroup === 1) {
    /**
     * Aff
     * @type {string}
     */
    location.href = "affindex.html";
  } else if (redirectGroup === 2) {
    if (redirectUrl.includes("/load")) {
      if (isLoggedIn) {
        if (window.userStatus === USER_STATUS.FREEZE_MONEY) {
          return alertBox({
            message: "抱歉! 你的资金已被冻结(只限查看明细可用), 请和上级联系。",
            type: "error",
          });
        }

        if (window.userStatus === USER_STATUS.FORBID_BETTING) {
          return alertBox({
            message: "抱歉! 你的账号已被冻结(只限结账功能可用), 请和上级联系。",
            type: "error",
          });
        }

        const lottery = redirectUrl;
        const lotteryArr = lottery.substring(1).split("/");
        const lotteryHall = "/player/lottery";

        /**
         * If no game is selected, go to default lottery
         */
        if (lotteryArr.length === 1) {
          location.href = lotteryHall;
        } else {
          const game = lotteryArr[1];
          location.href = `${lotteryHall}/${game}`;
        }
      } else {
        $("#modal-signup").addClass("active");
      }
    }
  } else if (redirectGroup === 3) {
    /**
     * Product
     * @type {string}
     */
    if (isLoggedIn) {
      if (window.isGuest === 1) {
        window.open(`/player/lottery?home=true&product=${redirectPage}`);
        return;
      }

      if (window.userStatus === USER_STATUS.FREEZE_MONEY) {
        return alertBox({
          message: "抱歉! 你的资金已被冻结(只限查看明细可用), 请和上级联系。",
          type: "error",
        });
      }

      if (window.userStatus === USER_STATUS.FORBID_BETTING) {
        return alertBox({
          message: "抱歉! 你的账号已被冻结(只限结账功能可用), 请和上级联系。",
          type: "error",
        });
      }

      location.href = "/player/lottery?home=true&product=" + redirectPage;
    } else {
      $("#modal-signup").addClass("active");
    }
  } else if (redirectGroup === 4) {
    /**
     * Other
     */
    const path = redirectUrl;

    switch (path) {
      case "/share":
        location.href = "#app-banner";
        return;
      case "/customerservice":
        const firstCustomerServiceUrl = $(".user-online-service-url-dropdown-wrapper__url").attr("href");
        location.href = firstCustomerServiceUrl || "help.html";
        return;
      case "/wechatAdmin":
        $("html").append(
          `<modal id="wechat-admin-modal" class="active">
                <iframe width="640" height="498" src="https://v.qq.com/iframe/player.html?vid=p03972tll8k&tiny=0&auto=0" frameborder allowfullscreen/>
             </modal>`
        );

        $("#wechat-admin-modal").on("click", function () {
          $(this).remove();
        });

        return;
      case "/faq":
        location.href = "help.html";
        return;
    }

    if (isLoggedIn) {
      switch (path) {
        case "/chatroom":
          location.href = "/player/lottery?redirect=chatroom";
          break;
        case "/interestWallet":
          location.href = "/player/lottery?redirect=yuebao";
          break;
        case "/payment/deposit":
          window.open("/payment/lontong/recharge");
          break;
        case "/payment/withdrawl":
          window.open("/player/withdrawal");
          break;
        case "/prediction/list":
          location.href = "/player/lottery?predict=true&lottery=default";
          break;
        case "/vip":
          location.href = "/player/lottery?redirect=VIP";
          break;
        case "/signin":
          location.href = "/player/lottery?redirect=checkin";
          break;
        case "/referral":
          location.href = "/player/lottery?redirect=referral";
          break;
        case "/loyalty":
          location.href = "/player/lottery?redirect=loyalty";
          break;
        default:
          location.href = "/player/lottery";
      }
    } else {
      $("#modal-signup").addClass("active");
    }
  } else if (redirectGroup === 5) {
    window.open(redirectUrl);
  }
}

$(function () {
  function initBannerCarousel() {
    const bannerList = window.banner;
    const indexContainer = $(".banner-carousel");

    bannerList?.forEach(function (item) {
      const { imageUrl, redirectUrl, redirectGroup, redirectPage, bannerType } = item;

      if (imageUrl) {
        /**
         * Redirect Group Option
         * 0 - Promo
         * 1 - Join Us
         * 2 - Lottery
         * 3 - Product
         * 4 - Others inner page (Loyalty, Customer Service)
         * 5 - 自定义
         */
        const banner = $(`
            <div class="carousel-cell" >
              <img 
                src="${imageUrl}"
                ${redirectUrl ? `data-redirecturl=${redirectUrl}` : ""}  
                data-redirectgroup=${redirectGroup}
                data-redirectpage=${redirectPage}
                loading="lazy"
              />
              <div class="img-bg" style="background-image: url(${imageUrl})"></div>
            </div>
          `);
        // /**
        //  * index append 首页type banner, promo append 优惠活动type banner
        //  * 轮播图类型 bannerType
        //  * 0 - 首页
        //  * 1 - 优惠活动
        //  * 2 - 其他
        //  */
        indexContainer.append(banner);
      }
    });

    if (document.querySelector(".banner-carousel")) {
      var flkty = new Flickity(".banner-carousel", {
        adaptiveHeight: true,
        setGallerySize: true,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 5000,
        on: {
          change: () => {
            flkty.playPlayer();
          },
        },
      });

      flkty.on("staticClick", function (event) {
        const { redirecturl, redirectgroup, redirectpage } = event.target.dataset;
        onBannerClicked(redirecturl, Number(redirectgroup), redirectpage);
        flkty.playPlayer();
      });
    }

    var currentString = $(
      ".sidebar-left .sidebar-left-content-wrapper .links-wrapper a[api-link='official.navigation.web']"
    ).attr("href");

    try {
      $(".sidebar-left-text-container .sidebar-left-text").text(new URL(currentString)?.hostname);
    } catch {
      $(".sidebar-left-text-container .sidebar-left-text").text(currentString);
    }
  }

  function hideSideBarItems() {
     if (window.location.pathname.split("/").pop() === "") {
        $(".sidebar-left").removeClass("hide");
      }
  }

  if (Pace) {
    Pace.on("done", function () {
      initBannerCarousel();
      hideSideBarItems();
    });
  } else {
    $(window).load(initBannerCarousel);
    $(window).load(hideSideBarItems);
  }
});

window.addEventListener(
  "changePassword",
  function ({
    detail: {
      data: { changePassword, remindChangePassword, remindChangePasswordMsg },
    },
  }) {
    const isShowCancelButton = !changePassword && remindChangePassword;
    const message = remindChangePasswordMsg || "为了您的账号安全，请重置密码";

    return alertBox({
      message: message,
      type: "info",
      cancelFunc: isShowCancelButton ? () => {} : undefined,
      confirmFunc: () => {
        window.location.href = "/player/changepassword";
      },
    });
  }
);

$(function () {
  if(location.search.includes('showPromo')) {
    $("#modal-promo").addClass("active");
  }
});
